export default "__VITE_ASSET__y80UyjVL__"